import grispiApi from '../../../apis/grispiApi';
import { EditTriggerFormValues } from '../../../components/TriggerPage/EditTriggerForm';
import { CreateTriggerFormValues } from '../../../components/TriggerPage/NewTriggerForm';
import { Trigger } from '../../../hooks/adminPage/triggers/useTriggers';

export const createTrigger = async (customTriggerPostData: CreateTriggerFormValues): Promise<void> => {
    await grispiApi.post('/triggers', customTriggerPostData);
};

export const editTrigger = async (customTriggerPostData: EditTriggerFormValues): Promise<void> => {
    const { id } = customTriggerPostData;
    await grispiApi.put(`/triggers/${id}`, customTriggerPostData);
};

export const deleteCustomTrigger = async (id: number): Promise<void> => {
    await grispiApi.delete(`/triggers/${id}`);
};

export const enableCustomTrigger = async (id: number): Promise<void> => {
    await grispiApi.delete(`/triggers/${id}/deactivation`);
};

export const disableCustomTrigger = async (id: number): Promise<void> => {
    await grispiApi.post(`/triggers/${id}/deactivation`);
};
export const sortTriggers = async (sortedTriggers: { triggerId: number; order: number }[]): Promise<void> => {
    await grispiApi.patch(`/triggers/order`, sortedTriggers);
};
export const getTriggerById = async (id: number): Promise<Trigger> => {
    const res = await grispiApi.get(`/triggers/${id}`);
    return res.data;
};
